/**
 * @deprecated Please implement the missing feature instead
 */
export class NotImplementedYet extends Error {
  constructor() {
    super('Not implemented yet');
  }
}

/**
 * Utility function to help statically analyse gaps in the library implementation
 * in the initial phase of the library creation.
 *
 * Deprecation flag helps to visually distinguish it in IDE
 * by adding a strikethrough. The function is intended to be phased out.
 *
 * @deprecated Please implement the missing feature instead
 */
export const notImplementedYet = () => {
  throw new NotImplementedYet();
};